/* eslint-disable no-param-reassign */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

export const fetchLearningCenter = createAsyncThunk(
  'fetchLearningCenter',
  async () => {
    const jwtToken = localStorage.getItem('myrJwtToken')
    const res = await axios.get(process.env.REACT_APP_LEARNINGCENTER_ENDPOINT, {
      headers: {
        JWT: jwtToken,
      },
    })
    return res.data
  },
)

// This is the initial state object the reducers and extraReducers will change based on whatever we need to change it to. It is required when creating the createSlice object.
const initialState = {
  status: 'idle',
  data: {
    title: 'Learning Center',
    workshopsData: [],
  },
}

const learningCenterSlice = createSlice({
  name: 'learningCenter',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchLearningCenter.rejected]: (state) => {
      state.status = 'error'
    },
    [fetchLearningCenter.pending]: (state) => {
      state.status = 'pending'
    },
    [fetchLearningCenter.fulfilled]: (state, action) => {
      state.status = 'fulfilled'
      state.workshopsData = action.payload
    },
  },
})

export const selectLearningCenterData = (state) =>
  state.learningCenter.workshopsData
export const selectLearningCenterStatus = (state) => state.learningCenter.status

export default learningCenterSlice.reducer
